<script setup lang="ts">
import Editor from 'primevue/editor'
import { inject } from 'vue'

const toolbar = inject('quillToolbar')

defineProps(['modelValue'])
defineEmits(['update:modelValue'])
</script>

<template>
  <Editor
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :modules="{ toolbar }"
    :formats="['bold', 'italic', 'link']"
  />
</template>

<style>
.p-editor-toolbar {
    display: none !important;
}
</style>